import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubjectSyllabus } from "@src/api/SyllabusApiSlice";

interface Chapter {
  chapterId: number;
  chapterName: string;
  pages: number;
}

interface Subject {
  id: number;
  subjectName: string;
  type: string;
  questionType: string;
  description: string;
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  chapters: Chapter[];
}

interface SubjectState {
  subjects: Subject[] | SubjectSyllabus[];
  subjectId: string;
  subjectName: string;
  subjectCategory: string;
  programmingLanguage: string[];
  syllabusId: string;
  syllabusName: string;
  subjectData: SubjectSyllabus | null;
  type: string;
  overview?: string;
  logo?: string;
  icon?: string;
  subjectLogo?: string;
}

const initialState: SubjectState = {
  subjects: [],
  subjectId: "",
  subjectName: "",
  subjectCategory: "",
  programmingLanguage: [],
  syllabusId: "",
  syllabusName: "",
  subjectData: null,
  type: "",
  overview: "",
  logo: "",
  icon: "",
  subjectLogo: "",
};

const subjectSlice = createSlice({
  name: "subject",
  initialState,
  reducers: {
    setSubjects(state, action: PayloadAction<Subject[] | SubjectSyllabus[]>) {
      state.subjects = action.payload;
    },
    setSelectedSubject(state, action: PayloadAction<Partial<SubjectState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setSubjects, setSelectedSubject } = subjectSlice.actions;
export default subjectSlice.reducer;
